import { AUTH_INPUT_ITEM_TYPE } from 'shared';

export const SYNERGY_ID_FREE = {
  authenticationInputItemType: AUTH_INPUT_ITEM_TYPE.synergyIdFree,
  synergyId: '',
};
export const TEXT_FREE = {
  authenticationInputItemType: AUTH_INPUT_ITEM_TYPE.textFree,
  text: '',
};
export const MAIL_ADDRESS_FREE = {
  authenticationInputItemType: AUTH_INPUT_ITEM_TYPE.mailAddressFree,
  mailAddress: '',
};
export const NUMBER_FREE = {
  authenticationInputItemType: AUTH_INPUT_ITEM_TYPE.numberFree,
  number: '',
};
export const PASSWORD_HASH_FREE = {
  authenticationInputItemType: AUTH_INPUT_ITEM_TYPE.passwordHashFree,
  password: '',
};
export const DATE_FREE = {
  authenticationInputItemType: AUTH_INPUT_ITEM_TYPE.dateFree,
  year: '',
  month: '',
  day: '',
};
export const MONTH_DAY_FREE = {
  authenticationInputItemType: AUTH_INPUT_ITEM_TYPE.monthDayFree,
  month: '',
  day: '',
};
